

import "./Ribbons";
import "./ShipIconComponent";
export * from "./ShipIconComponent";
export * from "./StatusColorComponent";
export * from "./FileUploadControl";

import "@eavfw/monaco-editor-control";
import "@eavfw/quickform-designer";
import { RegisterFeature } from "@eavfw/apps";
import { useEAVForm } from "@eavfw/forms";
import "./DocumentsViewer/DocumentsViewer";
import { useEffect, useMemo, useState } from "react";
import "@eavfw/quickform-core/src/components/question/input-types/text/TextInput";
import "@eavfw/quickform-core/src/components/question/input-types/multiline/MultilineInput";
import "@eavfw/quickform-input-select";

RegisterFeature("WizardExpressionsProvider", (formValues: any) => {
    console.log("WizardExpressionsProvider", [formValues]);
    //   const [brokerNotFound] = useEAVForm(x => x.formValues?.brokerFound);
    const brokerNotFound = formValues?.brokerFound;
    const vesselNotFound = formValues?.vesselFound;

    return {
        "@not(coalesce(avform().brokerFound,true))": typeof (brokerNotFound) === "undefined" ? false : !brokerNotFound,
        "@not(coalesce(avform().vesselFound,true))": typeof (vesselNotFound) === "undefined" ? false : !vesselNotFound
    }
});


RegisterFeature("ExpressionsProviderAsync", (formValues:any, expression: string) => {

   
    console.log("ExpressionsProviderAsync", [formValues, expression]);
   
    switch (expression) {
        case "@coalesce(ctx()?.provider?.configuration,json('{\"visible\": false }'))":
            return new Promise((resolve, reject) => resolve(formValues?.provider?.configuration ?? {visible:false}));
        case "@jsonPath(ctx(),'$.providers[*].name')":
            return new Promise((resolve, reject) => resolve(formValues?.providers?.map((x: any) => x.name)));
        case "@ctx()?.providers":
            return new Promise((resolve, reject) => resolve(formValues?.providers));
        case "@jsonPath(ctx(),'$.accounts[*].account_name')":
            return new Promise((resolve, reject) => resolve(formValues?.accounts?.map((x: any) => x.account_name)));
        case "@ctx()?.accounts":
            return new Promise((resolve, reject) => resolve(formValues?.accounts));
        case "<div>Please Open the following <a href=\"@ctx()?.consentUrl\">consent url<a/> to give consent to @ctx().provider.name<div>":
            return new Promise((resolve, reject) => resolve(`<div>Please Open the following <a href="${formValues?.consentUrl}" target="_bank">consent url</a> to give consent to ${formValues?.provider?.name}<div>`));
    }

    throw new Error(`expression '${expression}' was not implemented`);
});

RegisterFeature("ExpressionsProvider", (expression: string) => {

    const [formValues] = useEAVForm(x => x.formValues);
    console.log("ExpressionsProvider", [formValues, expression]);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const t = setTimeout(() => { setIsLoading(false); }, 300);
        return () => clearTimeout(t);
    });

    const evaluated = useMemo(() => {
        switch (expression) {
            case "@jsonPath(ctx(),'$.accounts[*].account_name')":
                return formValues?.accounts?.map((x: any) => x.account_name);
            case "@ctx()?.accounts":
                return formValues?.accounts;
            case "<div>Please Open the following <a href=\"@ctx()?.consentUrl\">consent url<a/> to give consent to @ctx().provider.name<div>":
                return `<div>Please Open the following <a href="${formValues?.consentUrl}" target="_bank">consent url</a> to give consent to ${formValues?.provider?.name}<div>`;
        }
    }, [expression, formValues]);
    return { isLoading, evaluated }
});
